import DownloadLink from 'components/DownloadLink';
import Icon from 'components/Icon';
import BooleanValue from 'components/Value/BooleanValue';
import {FC} from 'react';

import {CustomTemplateItem} from '../../services';

type TableCellContentProps = {
    columnKey: keyof CustomTemplateItem;
    item: CustomTemplateItem;
};

const TableCellContent: FC<TableCellContentProps> = ({columnKey, item}) => {
    if (columnKey === 'partner') {
        return (
            <a
                className="inline-flex items-center gap-1"
                href={item.partner.url}
                rel="noreferrer"
                target="_blank"
            >
                {item.partner.name}
                <Icon icon="open_blank" size="base" />
            </a>
        );
    }

    if (columnKey === 'displayName') {
        return (
            <a
                className="inline-flex items-center gap-1"
                href={item.url}
                rel="noreferrer"
                target="_blank"
            >
                {item.displayName}
                <Icon icon="open_blank" size="base" />
            </a>
        );
    }

    if (columnKey === 'uploadedFileUrl') {
        return (
            <DownloadLink className="mb-1 ml-1" href={item.uploadedFileUrl}>
                xlsx
            </DownloadLink>
        );
    }

    if (columnKey === 'templateFileUrl') {
        return (
            <DownloadLink className="mb-1 ml-1" href={item.templateFileUrl}>
                ods
            </DownloadLink>
        );
    }

    if (columnKey === 'draft') {
        return <BooleanValue value={item.draft} />;
    }

    return <span>{item[columnKey]}</span>;
};

export default TableCellContent;
